export default __webpack_public_path__ + "static/media/bracket.6e488741.svg";